// todo заменить на реальную фукнцию с типизаций
import {identity as orderPath} from '@logistics-frontend/utils'
import {formatOfferInterval as _formatOfferInterval} from '@yandex-delivery/form'

import {i18n} from '../config'
import {toDate} from './date-time'
import {formatPrice} from './format-price'
import {fromPaymentInfo} from './from-payment-info'
import {fromSddExpressProduct} from './from-sdd-express-product'
import {fromSuggestToPointAddress} from './from-suggest-to-point-address'
import {getPointId} from './get-point-id'
import {getProducts} from './get-products'
import {mapVerticalToDeliveryType} from './map-vertical-to-delivery-type'
import {toFiscalizaitonIfPaymentOnDemand} from './to-fiscalization-if-payment-on-demand'
import {toGeoLocation} from './to-geo-location'
import {toPaymentInfo} from './to-payment-info'

const formatOfferInterval = _formatOfferInterval(i18n)

export {
  formatOfferInterval,
  formatPrice,
  fromPaymentInfo,
  fromSddExpressProduct,
  fromSuggestToPointAddress,
  getPointId,
  getProducts,
  mapVerticalToDeliveryType,
  orderPath,
  toDate,
  toFiscalizaitonIfPaymentOnDemand,
  toGeoLocation,
  toPaymentInfo,
}
